module.exports = "dist/mapa_menu_rodape.png?9ba06e19d16711af772ba74228967da7";